import { useQueryClient } from "@tanstack/react-query";
import { ChevronsUpDown, LogOut, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@krea/shared/design-system/Dropdown";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@krea/shared/design-system/sidebar";
import { useAuthStore } from "@krea/shared/features/auth/authStore";

import { useGetCurrentLenderCompanyQuery } from "@/features/lender-companies/hooks/use-get-lender-company.query";
import { MeAvatar } from "@/features/users/components/me-avatar";

export const NavUser = () => {
  const { isMobile } = useSidebar();

  const resetStore = useAuthStore((state) => state.reset);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const onLogout = () => {
    resetStore();
    queryClient.clear();
    navigate("/login");
  };

  const { data: lenderCompany } = useGetCurrentLenderCompanyQuery();

  const onSettings = () => {
    navigate(`/lender-company/${lenderCompany?.id}/profile`);
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-gray-100 data-[state=open]:text-black"
            >
              <MeAvatar />

              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <MeAvatar />
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem className="gap-2" onClick={onSettings}>
                <Settings />
                Settings
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />

            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onLogout} className="gap-2">
              <LogOut />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
